import { OBSTACLE_SUBTYPE, OBSTACLE_TYPE } from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const RRRED = {
  isDark: false,
  startHealth: 30,
  timeAllowedSecs: 100,
  textColor: "#ffff00",
  textColorHighlight: "#ffffff",
  bgColor: "#660000",
  bgFadeAlpha: 0.55,
  gameplayAreaToCanvasLateralRatio: 0.8,
  controllerSpeedDamp: 10,
  tip: "MOVE FAST TO EAT WELL",
  player: {
    color: "#ffffff",
    growthDivisor: 200,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 500,
      color_ar: ["#ff8888", "#ee8888", "#dd8888"],
      radiusRange: [1, 3],
      directionRange: [175, 185],
      speedRange: [0.001, 0.03],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 230,
      color_ar: ["#FFBF00", "#FFEA00", "#FAFA33"],
      radiusRange: [11, 13],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 4,
      color_ar: ["#ff0000"],
      radiusRange: [25, 35],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [15, 19],
      rotationSpeedRange: [0.01, 1],
      shapeCenterRadiusDivisor: 5,
      shapeCenterColor_ar: ["#ff2200"],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_TWANG_SFX_AR,
      total: 77,
      color_ar: ["#FFBF00", "#FFEA00", "#FAFA33"],
      radiusRange: [20, 30],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 3,
      color_ar: ["#ff0000"],
      radiusRange: [70, 90],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [31, 31],
      rotationSpeedRange: [0.01, 1],
      shapeCenterRadiusDivisor: 5,
      shapeCenterColor_ar: ["#ff2200"],
    },
  ],
};
